@if ((loadingState$ | async); as state) {
  @if (state.isLoading) {
    <div class="loading-overlay">
      <div class="loading-backdrop"></div>
      <div class="loading-content">
        <mat-spinner diameter="24"></mat-spinner>
        @if (state.message) {
          <p class="loading-message">{{ state.message }}</p>
        }
      </div>
    </div>
  }
}
